import React, { useCallback, useState, useEffect } from 'react';
import classNames from 'classnames';
import './MainContainer.scss';
import { Route, Switch, useLocation } from 'react-router-dom';
import NavLinkComponent from 'src/components/NavLinkComponent';
import NotFoundContainer from 'src/components/NotFoundComponent';
import CityContainer from 'src/containers/city-container';
import WelcomeComponent from 'src/components/welcome-page/WelcomeComponent';
import NavigationContainer from '../navigation-container/NavigationContainer';
import UserContainer from '../user-container';
import CompanyContainer from '../company-container';
import ProductContainer from '../product-container';
import SingleMastersContainer from '../masters-container/index';
import CustomerContainer from '../customer-container/index';
import PermissionsContainer from '../permissions-container/index';
import AreaContainer from '../area-container/index';
import CatalogueContainer from '../catalogue-container/index';
import CommissionContainer from '../commission-container/index';
import CaseContainer from '../case-container/index';
import RptCaseStatus from '../reports/RptCaseStatus';
import Invoice from '../reports/Invoice';
import Receipt from '../reports/Receipt';
import Payment from '../reports/Payment';
import RptCaseList from '../reports/RptCaseList';
import RptInsuranceList from '../reports/RptInsuranceList';
import RptInsuranceCaseList from '../reports/RptInsuranceAlertList';
import RcPddList from '../reports/RcPddList';
import RptInsurancePayout from '../reports/RptInsurancePayout';
import AccntPayoutCal from '../reports/AccntPayoutCal';
import AccntInsuranceCal from '../reports/AccntInsuranceCal';
import TargetContainer from '../target-container/index';
import WalletContainer from '../wallet-container/index';
import InsuranceSlabContainer from '../insurance-slab-container/index';
import InsuranceContainer from '../wallet-container/index';
import AdvanceExpense from '../reports/AdvanceExpense';
import SalesReport from '../reports/SalesReport';
import RtoList from '../reports/RtoList';
import BEMgrSalesReport from '../reports/BEMgrSalesReport';

function MainContainer() {
    const location = useLocation();

    const [
        sideBarState,
        setSideBarState,
    ] = useState(false);

    const closeSideBar = useCallback(() => {
        setSideBarState(false);
    }, [
        setSideBarState,
    ]);

    const openSideBar = useCallback(() => {
        setSideBarState(true);
    }, [
        setSideBarState,
    ]);

    // close side bar on route change
    useEffect(() => {
        closeSideBar();
    }, [
        location,
        closeSideBar,
    ]);

    return (
        <>
            <div className={classNames({
                'page-wrapper chiller-theme': true,
                toggled: sideBarState,
            })}
            >
                <NavLinkComponent
                    id="show-sidebar"
                    className="btn btn-sm btn-dark"
                    onClick={openSideBar}
                >
                    <i className="fas fa-bars" />
                </NavLinkComponent>

                <NavigationContainer
                    closeSideBar={closeSideBar}
                    openSideBar={openSideBar}
                />

                <main className="page-content">
                    <Switch>
                        <Route
                            path="/"
                            exact
                            component={WelcomeComponent}
                        />
                        <Route
                            path="/user"
                            component={UserContainer}
                        />
                        <Route
                            path="/city"
                            component={CityContainer}
                        />
                        <Route
                            path="/area"
                            component={AreaContainer}
                        />
                        <Route
                            path="/company"
                            component={CompanyContainer}
                        />
                        <Route
                            path="/product"
                            component={ProductContainer}
                        />
                        <Route
                            path="/masters"
                            component={SingleMastersContainer}
                        />

                        <Route
                            path="/catalogue"
                            component={CatalogueContainer}
                        />
                        <Route
                            path="/commission"
                            component={CommissionContainer}
                        /> 
                        <Route
                            path="/teamTarget"
                            component={TargetContainer}
                        />
                          <Route
                            path="/wallet"
                            component={WalletContainer}
                        />
                        <Route
                            path="/insurance-slab"
                            component={InsuranceSlabContainer}
                        />
                        <Route
                            path="/customer"
                            component={CustomerContainer}
                        />
                        <Route
                            path="/case"
                            component={CaseContainer}
                        />
                        <Route
                            path="/permissions"
                            component={PermissionsContainer}
                        />

                        <Route
                            path="/invoice/:caseId"
                            component={Invoice}
                        />
                        <Route
                            path="/receipt/:caseId"
                            component={Receipt}
                        />
                        <Route
                            path="/payment/:caseId"
                            component={Payment}
                        />

                        <Route
                            path="/reports/payout-calculation"
                            component={RptCaseStatus}
                        />
                        <Route
                            path="/reports/insurance-payout"
                            component={RptInsurancePayout}
                        />
                        <Route
                            path="/reports/case-list"
                            component={RptCaseList}
                        />
                        <Route
                            path="/reports/insurance-report"
                            component={RptInsuranceList}
                        />
                        <Route
                            path="/reports/account-Payout"
                            component={AccntPayoutCal}
                        />
                        <Route
                            path="/reports/account-insurance-payout"
                            component={AccntInsuranceCal}
                        />
                        <Route
                            path="/reports/insurance-renewal-alert"
                            component={RptInsuranceCaseList}
                        />
                        <Route
                            path="/reports/rc-pdd-report"
                            component={RcPddList}
                        />
                        <Route
                            path="/reports/RTO-report"
                            component={RtoList}
                        />
                        <Route
                            path="/reports/advance-expense-report"
                            component={AdvanceExpense}
                        />
                        <Route
                            path="/reports/sales-report"
                            component={SalesReport}
                        />
                        <Route
                            path="/reports/back-end-manager-sales-report"
                            component={BEMgrSalesReport}
                        />
                        <Route
                            component={NotFoundContainer}
                        />
                    </Switch>
                </main>
            </div>
        </>
    );
}

export default MainContainer;
